'use client';
import {RawIntlProvider, createIntl, createIntlCache} from 'react-intl';
import Czech from '../../lang/cs.json';

const intlCache = createIntlCache();

export const IntlProvider = ({children}: {children: React.ReactNode}) => {
    return (
        <RawIntlProvider
            value={createIntl(
                {
                    locale: 'cs',
                    messages: Czech,
                    formats: {
                        number: {
                            CS: {
                                style: 'currency',
                                currency: 'CZK',
                            },
                            EN: {
                                style: 'currency',
                                currency: 'US',
                            },
                        },
                    },
                },
                intlCache,
            )}
        >
            {children}
        </RawIntlProvider>
    );
};
